import React from 'react';
import { Supplier } from '../../graphql/entities';
import SupplierOverviewTab from '../../views/supplier/SupplierOverviewTab';
import { FilterOperation, IFilterInput } from '../../graphql/schema/p4types';
import { useSupplierTotals } from './useSupplierTotals';
import { useFormQuery } from '../../graphql/containers/useFormQuery';
import { EntityType } from '../../@types/entityTypes';

type ISupplierSidebarFormProps = {
  id: number;
  sidebar: boolean;
};

const SupplierSidebarForm = ({ sidebar, id }: ISupplierSidebarFormProps) => {
  const formData = useFormQuery({ instance: Supplier.instance! } as EntityType, {
    duplicate: true,
    overrideParams: { id: id },
  });

  const supplierIdFilter: Array<IFilterInput> = [
    {
      filterOperation: FilterOperation.Equals,
      filterParameters: {
        field: 'supplier.id',
        value: `${id}`,
      },
    },
  ];

  const { orders, outstandingSum, awaitingApprovalSum } = useSupplierTotals(supplierIdFilter, id);

  if (!formData?.data) {
    return null;
  }

  return (
    <SupplierOverviewTab
      id={id}
      sidebar={sidebar}
      values={{ ...formData.data }}
      orders={orders}
      outstandingSum={outstandingSum}
      awaitingApprovalSum={awaitingApprovalSum}
    />
  );
};

export default SupplierSidebarForm;
